export function mapSlideIdsToIndices(swiperInstance) {
  //setSwiperInstance={(swiper) => (pageSwiperInstance.current = swiper)}
  const slides = swiperInstance?.current.slides ?? document.querySelectorAll(".swiper-slide");
  const idToIndexMap = {};

  slides.forEach((slide, index) => {
    if (slide.id) {
      idToIndexMap[slide.id] = index;
    }
  });

  return idToIndexMap;
}

export function findIndexOfSlideById(slideId) {
  const slides = document.querySelectorAll(".swiper-slide");
  for (let i = 0; i < slides.length; i++) {
    if (slides[i].id === slideId) {
      return i;
    }
  }
  return -1;
}

export function viewSlideById(swiperInstance, idToIndexMap, slideId) {
  var slideIndex = idToIndexMap[slideId];

  if (slideIndex !== undefined) {
    // swiperInstance.current.slideTo(slideIndex);
    viewSlideByIndex(swiperInstance, slideIndex);
  } else {
    // console.log(`No slide found with ID: ${slideId}`);
    if (window.scrollY) window.scrollY(0);
  }
}

export function viewSlideByIndex(swiperInstance, slideIndex) {
  if (swiperInstance.current) {
    swiperInstance.current.slideTo(slideIndex);
  }
}
